import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { MediaQuery, LazyImage } from '@grandvisionhq/common';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const Images = ({ front , angle  })=>{
    // Default width and height to set the right aspect ratios 320/180 = 16:9
    const defaultSettings = {
        width: 320,
        height: 180,
        rootMargin: '150px 0px'
    };
    const isPhone = MediaQuery.useIsPhone();
    const { getLabel  } = useIntl();
    const Placeholder = (src, alt)=>/*#__PURE__*/ React__default.createElement("div", {
            className: "product-block-image-placeholder"
        }, /*#__PURE__*/ React__default.createElement(SkeletonLoader, null, /*#__PURE__*/ React__default.createElement("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            height: "220",
            "aria-label": getLabel('common.loadingText')
        }, /*#__PURE__*/ React__default.createElement("rect", {
            width: "100%",
            height: "100",
            rx: "5",
            fill: "currentColor"
        }), /*#__PURE__*/ React__default.createElement("rect", {
            width: "80%",
            height: "15",
            rx: "5",
            fill: "currentColor",
            x: "10%",
            y: "140"
        }), /*#__PURE__*/ React__default.createElement("rect", {
            width: "80%",
            height: "15",
            rx: "5",
            fill: "currentColor",
            x: "10%",
            y: "165"
        }), /*#__PURE__*/ React__default.createElement("rect", {
            width: "50%",
            height: "15",
            rx: "5",
            fill: "currentColor",
            x: "25%",
            y: "200"
        }))), /*#__PURE__*/ React__default.createElement("noscript", null, /*#__PURE__*/ React__default.createElement("img", {
            src: src,
            alt: alt,
            width: defaultSettings.width,
            height: defaultSettings.height
        })))
    ;
    return /*#__PURE__*/ React__default.createElement("section", {
        className: classnames('product-block-image-wrapper', {
            // Only enable hover behaviour if we have have an angle image as well and are not on a phone
            'product-block-image-wrapper--hover': !!angle && !isPhone
        }),
        style: {
            paddingBottom: `${defaultSettings.height / defaultSettings.width * 100}%`
        }
    }, front && /*#__PURE__*/ React__default.createElement("figure", {
        className: "product-block-image product-block-image--front"
    }, /*#__PURE__*/ React__default.createElement(LazyImage, swcHelpers.extends({}, defaultSettings, {
        className: "product-block-image__lazy-image",
        src: front.url,
        alt: front.alt || '',
        srcSet: front.srcSet,
        sizes: front.sizes,
        placeholder: Placeholder(front.url, front.alt)
    }))), angle && !isPhone && /*#__PURE__*/ React__default.createElement("figure", {
        className: "product-block-image product-block-image--angle"
    }, /*#__PURE__*/ React__default.createElement(LazyImage, swcHelpers.extends({}, defaultSettings, {
        className: "product-block-image__lazy-image",
        src: angle.url,
        alt: angle.alt || '',
        srcSet: angle.srcSet,
        sizes: angle.sizes,
        placeholder: Placeholder(angle.url, angle.alt)
    }))));
};
var Images$1 = Images;

export { Images, Images$1 as default };
//# sourceMappingURL=Images.js.map
